// AcceptAdditionalPage.js
import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import "../invite.css";

const AcceptAdditionalPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const projAddItemId = new URLSearchParams(window.location.search).get("adwid");

    const handleAccept = async () => {
      if (!projAddItemId) {
        console.warn("❌ Missing projAddItemId in query string");
        setErrorMessage("Missing project additional item ID in the URL.");
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        // 🔹 Step 1: Get customer ID from new API (POST)
        let getCustData;
        try {
          const getCustRes = await fetch(
            `${BASE_URL}/Customer/GetProjAddItemByProAddItemID_ByCust_New`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ ID: parseInt(projAddItemId, 10) }),
            }
          );

          if (!getCustRes.ok) {
            const errorText = await getCustRes.text();
            throw new Error(`API failed with status ${getCustRes.status}: ${errorText}`);
          }

          getCustData = await getCustRes.json();
        } catch (err) {
          console.error("Failed to fetch customer data:", err);
          throw new Error("Failed to fetch customer information: " + err.message);
        }

        if (!getCustData?.isSuccess || !getCustData.customerID) {
          throw new Error(getCustData?.message || "Invalid customer data received from server.");
        }

        const customerID = getCustData.customerID;

        // 🔹 Step 2: Send approval request with customerID
        try {
          const response = await fetch(
            `${BASE_URL}/ProjectAdditionalItem/UpdateProjectAdditionalItemApprovalStatus`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                projectAdditionalItemID: parseInt(projAddItemId, 10),
                customerID: parseInt(customerID, 10),
                statusID: 1, // ✅ 1 = Accept
              }),
            }
          );

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Approval failed with status ${response.status}: ${errorText}`);
          }

          const approvalResponse = await response.json();
          if (!approvalResponse?.isSuccess) {
            throw new Error(approvalResponse?.message || "Approval request failed on server.");
          }

          setSuccess(true);
        } catch (err) {
          console.error("Failed to approve Additional Item:", err);
          throw new Error("Failed to approve Additional Item: " + err.message);
        }
      } catch (error) {
        console.error("❌ Error in handleAccept:", error);
        setErrorMessage(error.message || "An unexpected error occurred.");
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleAccept();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaCheck size={48} color="#a0b750" />
            </div>
            <h2 className="card-title">Approved</h2>
            <p className="card-msg">Additional Item has been Approved successfully!</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaCheck size={48} color="#888" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">
              {errorMessage || "Unable to approve Additional Item. Please try again later."}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptAdditionalPage;
